module.exports = __webpack_public_path__ + "img/kairan.d4dbbb0e.png";